import React from 'react'
import {NavLink}  from 'react-router-dom';
export default function Footer() {
  return (
    <div>
     
     <div className="footer">
      <div className='container'>
      <div className="flex flex-3 footertext  ">
        <h4>Term of use</h4>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.
           Ea, numquam? Sunt quidem qui provident.
            Cum ipsum accusamus quasi ullam a nihil omnis in autem maxime!
          </p>

      </div>

      <div className="flex flex-3 footertext">
        <h4>Our Policy</h4>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, 
          odio recusandae fuga laboriosam nobis, corrupti eos beatae, 
          numquam id accusamus voluptates incidunt minus commodi provident? Quos, ab.
          .</p>

      </div>
         
      <div className="flex flex-3 footertext">
        <h4>Info</h4>
        <p> 
          Phone : + 509 0247-9825 <br/>
           E-mail : coffeecorner@yahoo.fr
                 
         .</p>
         <NavLink  exaxt to ="/contact"> <button className='btn '>Contact by mail</button></NavLink>

      </div>
      <div className='flex flex-3 foootertext'>
          <p className='copy'>&copy; All rights reserved 2023 !</p>
          <h3 className='devby'>Powered By JcerelusDev</h3>
         </div>
         </div>


      </div>

          

    </div>
  )
}
